import { Fragment, FunctionalComponent, h } from '@stencil/core';

interface IntDropdownProps {
    countries: {
        name: string;
        url: string;
    }[];
}

export const IntDropdown: FunctionalComponent<IntDropdownProps> = ({ countries }) => {
    const openDropdown = () => {
        document.querySelector(".e-header__backdrop")?.classList.add('show');
        document.querySelector(".international-dropdown")?.classList.add('show');
    };

    const onUsExperience = countries.some(({ url }) => url === location.pathname);


    return (
        <Fragment>
            <div class="e-header__item" aria-expanded="false" aria-haspopup="menu">
                <div class="eds-app-launcher"></div>
            </div>
            <div class="e-header__item" aria-expanded="false" aria-haspopup="menu">
                <div class="eds-account-menu">
                    <ul class="account-menu" role="menu">
                        <li class="offset-item e-header-top-item" aria-expanded="false">
                            <button
                                type="button"
                                class="e-header__item-top offset-toggle account-menu-selector"
                                onClick={openDropdown}
                            >
                                <i class="icon icon-globe icon--left"></i>
                            </button>
                            <div class="international-dropdown">
                                <ul>
                                    <li class="dropdown-item placeholder">Please select a site</li>
                                    {onUsExperience && (
                                        <li class="dropdown-item selectable" onClick={() => window.location.href = "/"}>Go Back</li>
                                    )}
                                    {countries
                                        .filter(country => {
                                            // Extract pathname from country.url if it's a full URL
                                            let countryPath = country.url;
                                            try {
                                                const url = new URL(country.url);
                                                countryPath = url.pathname;
                                            } catch (e) {
                                                // If not a valid URL, use as is (likely already a path)
                                            }

                                            return countryPath !== location.pathname;
                                        })
                                        .map(country => (
                                            <li class="dropdown-item selectable" onClick={() => window.location.href = country.url}>
                                                {country.name}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <a class="log-in e-header__item-top e-header-top-item" href="/en/myericsson" rel="nofollow">Sign in</a>
                </div>
            </div>
        </Fragment>
    );
};